/* eslint-disable no-mixed-operators */
import { FormattedMessage } from 'react-intl'
import { Gray } from '../assets/colors'

// eslint-disable-next-line consistent-return
function getTextStyle(textType) {
  if (textType === 'header') {
    return {
      display: 'block',
      fontSize: '20px',
      color: Gray,
    }
  } if (textType === 'label') {
    return {
      display: 'block',
      fontSize: '12px',
      color: Gray,
      margin: 0,
    }
  }
}

interface TextProps {
  text?: any
  textType?: any
  style?: any
  plainText?: any
  children?: any
  testId?: string
}

function Text({
  text, textType, style, plainText, children, testId,
}: TextProps) {
  return (
    <div data-testid={testId} style={{ ...getTextStyle(textType), ...style }}>
      {plainText || (children && <FormattedMessage id={`${children}`} />) || text && <FormattedMessage id={`${text}`} /> }
    </div>
  )
}

export default Text
